<template>
  <div>
    <PageHeader title="ビルメンツ・見積" style="min-width: 1120px">
      <template #title-header-content>
        <div class="flex-1 flex items-center font-bold justify-end">
        <div class="text-xs text-white w-fit mx-auto self-center">ヒットしない場合は検索条件を変えてください。</div>
          <!-- 物件名 -->
          <div class="">
            <div class="text-white text-xs mb-1 ">物件名（部分一致）</div>
            <input
              type="search"
              class="w-full py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 text-sm font-bold"
              v-model="site"
            />
          </div>
          <div class="text-white mx-1 text-xs mt-auto">もしくは</div>
          <div class="">
            <div class="text-white text-xs mb-1 font-bold">物件住所（部分一致）</div>
            <input
              type="search"
              class="w-80 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 text-sm font-bold"
              v-model="address"
            />
          </div>
          <div class="text-white mx-1 text-xs mt-auto">もしくは</div>
          <div class="">
            <div class="text-white text-xs mb-1 font-bold">物件コード（完全一致）</div>
            <input
              type="search"
              class="w-32 py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 text-sm font-bold"
              v-model="code"
            />
          </div>

          <div class="mt-auto w-fit">
            <PrimaryButton text="検索" class="ml-2" @click="getData()">
              <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
            </PrimaryButton>
          </div>

          <!-- <Icon
            iconName="Refresh"
            :clickable="false"
            :class="{'animate-spin': loading}"
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="refresh"
          /> -->
        </div>
      </template>
    </PageHeader>

    <main class="absolute bottom-4 w-full top-20">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md overflow-auto h-full ">

          <div class="border border-green-700 rounded min-w-max">
            <div class="p-2 bg-green-100 text-green-700 font-bold cursor-pointer rounded-t" @click="akbsOpen=!akbsOpen">
              AKBS ビルメンツ <span v-if="loading2" class="animate-pulse">Loading...</span><span v-else>{{ akbs.length }}件</span><span v-if="!loading2" class="pl-5"><span v-if="akbsOpen">▼</span><span v-else>▶</span></span>
            </div>
            <div v-if="akbsOpen" class="px-2 min-w-max">
              <div v-for="(row, i) in akbs" :key="'rp'+i" class="text-sm text-gray-700 py-4 border-b border-gray-300">
                <div class="flex">
                  <div class="px-2 font-bold">{{ row.nameSite }}</div>
                  <div class="px-2">（物件コード：{{ row.cdSite }}）</div>
                  <div class="px-2 text-xs">{{ row.address }}</div>
                  <div v-if="row.yearly&&row.yearly.length" class="text-xs font-bold text-gray-600 ml-3">
                    <a :href="'https://akbs-systems.com/#/buildings/' + row.cdSite" target="_blank" rel="noopener noreferrer" class="text-xs text-blue-700 border-b border-blue-700">AKBS物件詳細</a>
                  </div>
                </div>
                <div class="text-teal-600 text-xs font-bold cursor-pointer pb-2" @click="openAkbsRow(row)">詳細<span v-if="row.open">▼</span><span v-else>▶</span></div>
                <div v-if="row.open" class="">
                  <!-- 年間契約 -->
                  <div v-if="row.yearly&&row.yearly.length" class="border border-teal-600 w-fit flex">
                    <div class="bg-green-700 text-white font-bold text-center p-2 " style="writing-mode: vertical-rl;">年間契約</div>
                    <div class="flex">
                      <div v-for="(d, j) in row.yearly" :key="i+'y'+j" class="p-2 border-teal-500" :class="j==row.yearly.length-1?'':'border-r'">
                        <!-- 作業名 -->
                        <div class="font-bold text-green-700 text-center">{{ d.nameKubunWorkContent }}</div>
                        <div class="font-bold text-green-700 text-center" v-if="d.nameKubunWorkContent!=d.nameWorkContent">（{{ d.nameWorkContent }}）</div>
                        <div v-else class="h-5"></div>
                        <!-- 回数 -->
                        <div class="mt-1.5 text-xs font-bold text-center" v-if="d.countWork&&d.countWork!='0'">{{ d.countWork }}{{ d.unitOfWork }}</div>
                        <div v-else class="mt-1.5 h-4"></div>

                        <!-- 金額 -->
                        <div class="ml-3 mt-1.5">受注年額 {{ d.totalFee.replace(/"/g, '') }} 円</div>
                        <div class="ml-3">{{ monthlyFee(d) }} </div>

                        <!-- 得意先名 -->
                        <div class="text-sm text-gray-600 font-bold mt-2 whitespace-nowrap">{{ d.nameBillingAddress1 }}</div>
                        <div class="text-sm text-gray-600 font-bold whitespace-nowrap">{{ d.nameBillingAddress2 }}</div>

                        <!-- 解約日 -->
                        <div v-if="d.dateCancellation" class="mt-2">
                          <div class="text-sm text-red-700 font-bold">{{ d.dateCancellation }} 解約</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- スポット -->
                  <div v-if="row.spots&&row.spots.length" class="mt-5 border border-teal-600 w-fit flex">
                    <div class="bg-teal-600 text-white font-bold text-center p-2 " style="writing-mode: vertical-rl;">スポット</div>
                    <div class="flex bg-teal-50">
                      <div v-for="(d, j) in row.spots" :key="i+'s'+j" class="text-sm text-gray-700 p-2 border-teal-500" :class="j==row.spots.length-1?'':'border-r'">
                        <!-- 作業名 -->
                        <div class="font-bold text-green-700 text-center">{{ d.nameKubunWorkContent }}</div>
                        <div class="font-bold text-green-700 text-center" v-if="d.nameKubunWorkContent!=d.nameWorkContent">（{{ d.nameWorkContent }}）</div>
                        <div v-else class="h-5"></div>
                        <div class="my-1.5 text-xs font-bold text-center">スポット</div>

                        <!-- 金額 -->
                        <div class="ml-3">受注 {{ d.totalFee.replace(/"/g, '') }} 円</div>
                        <div class="ml-3">{{ monthlyFee(d) }} </div>

                        <!-- 得意先名 -->
                        <div class="text-sm text-gray-600 font-bold mt-2 whitespace-nowrap">{{ d.nameBillingAddress1 }}</div>
                        <div class="text-sm text-gray-600 font-bold whitespace-nowrap">{{ d.nameBillingAddress2 }}</div>

                        <!-- 解約日 -->
                        <div v-if="d.dateCancellation" class="mt-2">
                          <div class="text-sm text-red-700 font-bold">{{ d.dateCancellation }} 解約</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="border border-blue-700 rounded min-w-max my-5">
            <div class="p-2 bg-blue-100 text-blue-700 rounded-t font-bold cursor-pointer" @click="rpOpen=!rpOpen">
              リクエストポスト見積り <span v-if="loading1" class="animate-pulse">Loading...</span>
              <span v-else>{{ rp.length }}件</span>
              <span v-if="!loading1" class="pl-5"><span v-if="rpOpen">▼</span><span v-else>▶</span><span class="pl-5">※検索対象外：「却下」「テストフラグON」</span></span>
            </div>
            <div v-if="rpOpen" class="rounded-b text-sm min-w-max">
              <table border="1" v-if="rp&&rp.length" class="min-w-max">
                <tr v-for="(key, i) in keys" :key="'key'+i" class="border-b">
                  <!-- カラム名 -->
                  <th class="text-left text-xs text-gray-700 p-2 bg-blue-50 whitespace-nowrap">{{ columnName(i)}}</th>
                  <td v-for="(row, j) in rp" :key="j+'rp'+i" class="px-2 border-r-2 border-l-2 border-gray-400">
                    <!-- 見積参照 -->
                    <div v-if="i==0" class="text-blue-700 border-b border-blue-700 cursor-pointer text-xs font-bold whitespace-nowrap" @click="toEstimate(row)">見積No.{{ row.estimateNo }}参照</div>
                    <!-- 物件名 -->
                    <div v-else-if="i==1" class="font-bold py-2"><p>{{ row.buildingName }}</p><p v-if="row.isHitSiteCode" class="text-xs">{{ checkSite(row.buildingName, row.buildingAddress2) }}</p></div>
                    <!-- 得意先名 -->
                    <div v-else-if="i==2" class="py-2">{{ row.clientName }}</div>
                    <!-- 区分 -->
                    <div v-else-if="i==5" class="text-center text-xs font-bold text-gray-700">{{ getType(row.classification) }}</div>
                    <!-- ステータス -->
                    <div v-else-if="i==6" class="text-center"><Badge class="" :color="EstimateStatusColorTable[getStatus(row.estimateStatus, row.orderStatus)]">{{ getStatus(row.estimateStatus, row.orderStatus) }}</Badge></div>
                    <!-- 住所・作業項目 -->
                    <div v-else class="text-xs py-2 whitespace-pre-line">{{ row[key] }}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="border border-purple-700 rounded">
            <div class="p-2 bg-purple-100 text-purple-700 font-bold cursor-pointer rounded-t" @click="richOpen=!richOpen">
              見積Rich <span v-if="loading3" class="animate-pulse">Loading...</span>
              <span v-else>{{ rich.length }}件</span>
              <span v-if="!loading3" class="pl-5"><span v-if="richOpen">▼</span><span v-else>▶</span><span v-if="!site" class="pl-5">※物件名がない場合、検索不可</span></span>
            </div>
            <div v-if="richOpen&&rich&&rich.length" class="w-full rounded-b">
              <table class="w-full rounded-b">
                <thead>
                  <tr class="text-xs bg-purple-50 text-gray-600">
                    <th scope="col" class="text-left p-2">案件番号</th>
                    <th scope="col" class="text-left p-2">見積番号</th>
                    <th scope="col" class="text-left p-2">案件名</th>
                    <th scope="col" class="text-left p-2">見積要件</th>
                    <th scope="col" class="text-right p-2">見積売価合計</th>
                    <th scope="col" class="text-right p-2">見積原価合計</th>
                    <th scope="col" class="text-center p-2">受注状態</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in rich" :key="'ri'+i" class="text-sm text-gray-700 hover-color">
                    <td class="p-2">{{ row.no }}</td>
                    <td class="px-2">{{ row.estimateNo }}</td>
                    <td class="px-2">{{ row.title }}</td>
                    <td class="px-2">{{ row.estimateTitle }}</td>
                    <td class="px-2 text-right">{{ row.amount }}</td>
                    <td class="px-2 text-right">{{ row.cost }}</td>
                    <td class="px-2 text-center">{{ row.orderStatus }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="text-transparent">{{reload}}</div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Badge from '@components/Badge.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import * as estimateManager from '@managers/estimateManager'
import * as constants from '@libs/constants'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'

import PageModel from '../../main/pages/PageModel.vue'
import { type } from '@/libs/constantsEstimate'

export default {
  extends: PageModel,
  components: {
    PageHeader,
    PrimaryButton,
    Badge,
    LoadingIcon
  },

  computed: {
    /**
     * どれか検索中ならtrue
     */
    loading() {
      if (this.loading1 || this.loading2 || this.loading3) {
        return true
      }
      return false
    },

    /**
     * カラム名
     */
    columnName() {
      return (i) => {
        switch (i) {
          case 0:
            return '参照画面'
          case 1:
            return '物件名'
          case 2:
            return '得意先名'
          case 3:
            return '物件住所'
          case 4:
            return '作業項目'
          case 5:
            return '区分名'
          case 6:
            return 'ステータス'
        }
      }
    }
  },

  data() {
    return {
      reload: 0,
      // RP
      loading1: false,
      // AKBS
      loading2: false,
      // 見積りッち
      loading3: false,
      // 物件名
      site: null,
      // 物件住所
      address: null,
      // 物件コード
      code: null,
      // RPヒット
      rp: [],
      // ビルメンヒット
      akbs: [],
      // 見積りッちヒット
      rich: [],
      // ステータスの色
      EstimateStatusColorTable: {},
      // 表示
      rpOpen: true,
      // 表示
      akbsOpen: true,
      // 表示
      richOpen: true,
      // RPのキー
      keys: ['estimateNo', 'buildingName', 'clientName', 'buildingAddress2', 'categorys', 'classification', 'status']
    }
  },

  async created() {
    // クエリーから受け取る
    if (this.$route.query) {
      this.site = this.$route.query.site
      this.address = this.$route.query.address
      this.code = this.$route.query.code

      constants.ESTIMATE_STATUS_COLOR.forEach((s) => {
        this.EstimateStatusColorTable[s.name] = s.color
      })
    }
    await this.getData()
  },

  methods: {
    /**
     * リフレッシュアイコンイベント
     */
    async refresh() {
      await this.getData()
    },

    /**
     * データ取得
     */
    async getData() {
      if (!this.site || !(this.site.trim)) {
        if (!this.address || !(this.address.trim)) {
          if (!this.code || !(this.code.trim)) {
            await dialogs.showErrorDialog('検索条件をどれか1つ入力してください', '検索条件がないため検索不可です。')
            return
          }
        }
      }
      if (this.address) {
        this.address = this.address.trim()
      }
      const filter = {
        site: this.site,
        address: this.address,
        code: this.code
      }

      // 検索
      this.getRp(filter)
      this.getAkbs(filter)
      this.getMitsumorich(filter)
    },

    /**
     * RPの見積りから検索
     */
    async getRp(filter) {
      this.loading1 = true
      this.rp = []
      const res = await estimateManager.serchEstimateHistory(this, filter)
      for (let i = 0; i < res.length; i++) {
        const r = res[i]
        const categorys = []
        // カテゴリー名を取得
        if (r.details && r.details.length) {
          for (let i = 0; i < r.details.length; i++) {
            const det = r.details[i]
            if (det.rowspan && det.rowspan > 0 && !categorys.includes(det.categoryName)) {
              categorys.push(det.categoryName)
            }
          }
        }
        r.categorys = categorys.join('\r\n')
      }
      this.rp = res
      this.loading1 = false
    },

    /**
     * AKBSから検索
     */
    async getAkbs(filter) {
      this.loading2 = true
      this.akbs = []
      const res = await backend.searchData('akbsTable/getAkbsHistory', filter)
      const list = {}

      if (res.data.data.length) {
        for (let i = 0; i < res.data.data.length; i++) {
          const l = res.data.data[i]
          if (!list[l.cdSite]) {
            list[l.cdSite] = {
              cdSite: l.cdSite,
              nameSite: l.nameSite,
              address: l.address,
              client1: l.nameBillingAddress1,
              client2: l.nameBillingAddress2,
              open: true,
              yearly: [],
              spots: []
            }
          }

          // スポット
          if (l.cdKubunAgreement == '9000') {
            list[l.cdSite].spots.push(l)
          // 年間
          } else {
            list[l.cdSite].yearly.push(l)
          }

        }
        for (let k = 0; k < Object.keys(list).length; k++) {
          const key = Object.keys(list)[k]
          this.akbs.push(list[key])
        }
      }
      this.loading2 = false
    },

    /**
     * みつもりっちから検索
     */
    async getMitsumorich(filter) {
      this.loading3 = true
      this.rich = []
      if (filter.site) {
        const res = await backend.searchData('mitsumorich/getMitsumorich', filter)
        if (res.data.data.length) {
          this.rich = res.data.data
        }
      }
      this.loading3 = false
    },

    /**
     * 物件コードで違った物件がヒットしている場合はメッセージ
     * @param 物件名
     * @param 住所
     */
    checkSite(site, address) {
      // 住所検索がある場合
      if (this.address && address) {
        const hankaku = utils.hankaku(this.address).replace('-', '').replace('丁目', '').replace('番地', '')
        const hankaku2 = utils.hankaku(address).replace('-', '').replace('丁目', '').replace('番地', '')
        if (hankaku.indexOf(hankaku2) == -1) {
          return '物件コードでヒットしたデータです。違う物件の可能性があります。'
        }
      }
      if (this.site) {
        const hankaku = utils.hankaku(this.site)
        const hankaku2 = utils.hankaku(site)
        if (hankaku.indexOf(hankaku2) == -1) {
          return '物件コードでヒットしたデータです。違う物件の可能性があります。'
        }
      }
    },

    /**
     * 状態を取得
     * @param status 見積りステータス
     * @param order 見積り受注のステータス
     */
    getStatus(status, order) {
      let res = status
      if (status == '受注') {
        if (order) {
          if (order.status) {
            res = order.status
          }
        }
      }
      return res
    },

    /**
     * 区分名取得
     */
    getType(val) {
      for (let i = 0; i < type.length; i++) {
        const t = type[i]
        if (t.id == val) {
          return t.name
        }
      }
    },

    /**
     * 見積りへ遷移
     * @param row 対象データ
     */
    toEstimate(row) {
      const route = this.$router.resolve({
        name: 'EstimateView',
        query: {
          estimateNo: row.estimateNo
        }
      })
      window.open(route.href, '_brank')
    },

    /**
     * 帳票PDF
     * @param row 対象データ
     */
    // toEstimatePDF(row) {
    //   const win = this.isModileDevice ? window.open() : null

    //   const printUrl = estimateManager.buildPrintUrlForDirectPrint(row, this.$store.getters.user.token, 'Estimate')
    //   if (printUrl) {
    //     if (win) {
    //       win.location = printUrl
    //     } else {
    //       window.open(printUrl)
    //     }
    //   }
    // },

    /**
     * AKBS詳細開閉
     */
    openAkbsRow(row) {
      row.open = !row.open
      this.reload++
    },

    /**
     * 毎月の登録金額を表示
     */
    monthlyFee(row) {
      const mm = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2]
      const month = []
      const fee = []
      let msg = ''

      for (let i = 1; i <= mm.length; i++) {
        const m = mm[i - 1]
        const f = row['feePlan' + i].replace(/"/g, '')
        if (f && f != '0') {
          month.push(m)
          if (!fee.includes(f)) {
            fee.push(f)
          }
        }
      }

      if (month.length) {
        if (month.length == 12) {
          msg = '【毎月】'
        } else {
          msg = '【' + month.join('・') + '月' + '】'
        }

        msg += ' ' + fee.join('、') + '円'
      }
      return msg
    },
  }
}
</script>

<style scoped>

.hover-color:hover {
  background: rgba(163, 231, 228, 0.67) !important;
}
</style>